import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import Main from '@/views/Main'

const routes = [
  {
    path: '/',
    name: 'main',
    component: Main,
    children: [
      {
        path: '/',
        name: 'index',
        component: resolve => require(['../views/index/index.vue'], resolve),
      },
      {
        path: '/solution',
        name: 'solution',
        component: resolve => require(['@/views/solution/index.vue'], resolve),
      },
      {
        path: '/charge',
        name: 'charge',
        component: resolve => require(['@/views/solution/charge.vue'], resolve),
      },
      {
        path: '/greenCity',
        name: 'greenCity',
        component: resolve => require(['@/views/solution/greenCity.vue'], resolve),
      },
      {
        path: '/customerCase',
        name: 'customerCase',
        component: resolve => require(['@/views/customerCase/index.vue'], resolve),
      },
      {
        path: '/aboutUs',
        name: 'aboutUs',
        component: resolve => require(['@/views/aboutUs/index.vue'], resolve),
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})
router.beforeEach((to, from, next) => {
  next()
})
export default router
